import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "../ui/dropdown-menu";
import { Receipt, AlertTriangle, FileText, Layers, Settings, ChevronDown, Users, Plug, Building2, Bell } from "lucide-react";

const SETTINGS_OPTIONS = [
  { id: "settings:users", label: "Users", icon: Users, adminOnly: true },
  { id: "settings:xero", label: "Xero Connector", icon: Plug },
  { id: "settings:netcash", label: "Netcash Connector", icon: Plug },
  { id: "settings:organization", label: "Organization Settings", icon: Building2 },
  { id: "settings:notifications", label: "Notification & Logging Preferences", icon: Bell },
];

function TabButton({ active, onClick, children, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`relative h-auto px-4 py-2.5 flex items-center gap-2 text-sm font-semibold rounded-lg transition-all duration-200 ${
        active
          ? "bg-slate-900 text-white dark:bg-blue-600 shadow-sm"
          : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
      }`}
    >
      {children}
    </button>
  );
}

export function NavRibbon({ active, onNavigate, isAdmin }) {
  const isSettings = active.startsWith("settings:");
  const options = SETTINGS_OPTIONS.filter((o) => !o.adminOnly || isAdmin);

  return (
    <nav className="sticky top-16 z-40 border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md">
      <div className="max-w-[1400px] mx-auto px-3 sm:px-6 py-2 flex items-center gap-1.5 overflow-x-auto">
        <TabButton active={active === "receipt-tracker"} onClick={() => onNavigate("receipt-tracker")} testId="nav-receipt-tracker">
          <Receipt className="h-4 w-4 shrink-0" />
          {/* Two-line wrapped label as required */}
          <span className="flex flex-col items-start leading-[1.05] text-left">
            <span>Receipt</span>
            <span>Tracker</span>
          </span>
        </TabButton>

        <TabButton active={active === "bounced-orders"} onClick={() => onNavigate("bounced-orders")} testId="nav-bounced-orders">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          Bounced Debit Orders
        </TabButton>

        <TabButton active={active === "invoices"} onClick={() => onNavigate("invoices")} testId="nav-invoices">
          <FileText className="h-4 w-4 shrink-0" />
          Invoices
        </TabButton>

        <TabButton active={active === "batches"} onClick={() => onNavigate("batches")} testId="nav-batches">
          <Layers className="h-4 w-4 shrink-0" />
          Batches
        </TabButton>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              data-testid="nav-settings"
              className={`h-auto px-4 py-2.5 flex items-center gap-2 text-sm font-semibold rounded-lg transition-all duration-200 ${
                isSettings ? "bg-slate-900 text-white dark:bg-blue-600 shadow-sm" : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
              }`}
            >
              <Settings className="h-4 w-4" />
              Settings
              <ChevronDown className="h-3.5 w-3.5" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-64">
            <DropdownMenuLabel>Settings</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {options.map((o) => (
              <DropdownMenuItem key={o.id} onClick={() => onNavigate(o.id)} data-testid={`nav-${o.id.replace(":", "-")}`} className="cursor-pointer gap-2.5">
                <o.icon className="h-4 w-4 text-slate-400" />
                {o.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </nav>
  );
}
